import React from 'react';

const DATE_FORMAT = { year: 'numeric', month: 'short', day: 'numeric' };

function formatDate(value) {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString(undefined, DATE_FORMAT);
}

function renderList(heading, duplicates) {
    return (
        <>
            <p className="mb-1">{heading}</p>
            <ul className="mb-2">
                {duplicates.map((duplicate) => (
                    <li key={duplicate.id}>
                        <a href={duplicate.link} target="_blank" rel="noopener noreferrer">
                            {__('Demo account #:id', { ':id': duplicate.id })}
                        </a>
                        {' '}
                        <span>{__('owner: :name', { ':name': duplicate.owner_name })}</span>
                        {' '}
                        <span className="text-muted">{__('created :date', { ':date': formatDate(duplicate.created_at) })}</span>
                    </li>
                ))}
            </ul>
        </>
    );
}

export default function DuplicateNotice({ own = [], others = [], confirmed, onConfirmChange }) {
    return (
        <div className="demo-add-duplicate-notice alert alert-warning" role="alert" data-testid="demo-add-duplicate-notice">
            {own.length === 0 && others.length === 0 &&
                <p className="mb-2" data-testid="demo-add-duplicate-generic">{__('A demo account for this business already exists.')}</p>
            }
            {own.length > 0 && renderList(__('You already have a demo account for this business:'), own)}
            {others.length > 0 && renderList(__('Other owners already have a demo account for this business:'), others)}
            <div className="custom-control custom-checkbox">
                <input
                    id="demo-add-duplicate-confirm"
                    data-testid="demo-add-duplicate-confirm"
                    type="checkbox"
                    className="custom-control-input"
                    checked={confirmed}
                    onChange={(event) => onConfirmChange(event.target.checked)}
                />
                <label className="custom-control-label" htmlFor="demo-add-duplicate-confirm">
                    {__('Create another demo account for this business anyway')}
                </label>
            </div>
        </div>
    );
}
